import {
  UTM_PARAMETER_NAMES,
  type UtmSubmission,
} from "@/types/components/UtmComponent";

const MAX_UTM_VALUE_LENGTH = 255;

export function captureUtmParameters(
  searchParams: URLSearchParams,
): UtmSubmission {
  return UTM_PARAMETER_NAMES.reduce<UtmSubmission>((utm, parameterName) => {
    const value = searchParams.get(parameterName)?.trim();

    if (value) {
      utm[parameterName] = Array.from(value)
        .slice(0, MAX_UTM_VALUE_LENGTH)
        .join("");
    }

    return utm;
  }, {});
}
